/**
 * paperDolls — split from `data.ts`'s legacy `PACKS` array into its own
 * module (narcis file-split shape), plan `thinking/plans/2026_08_31_toile_pack_wiring.md` Track A,
 * script `generation/scripts/packs/toile_split_data.py`.
 */
import {PORTRAIT, tagline, chips, type ToilePack} from './data'

export const paperDollsPack: ToilePack = {
    slug: 'paper-dolls',
    category: 'paperdolls',
    name: 'Paper dolls',
    tagline: tagline('sheets', 'dolls', 'styles'),
    chips: chips('dolls', 'styles'),
    ratio: PORTRAIT,
    readings: [
        {key: 'wardrobe', label: 'Doll & wardrobe', subject: 'a doll in a slip with six everyday outfits beside her'},
        {key: 'animal', label: 'Animal dress-up', subject: 'a bear cub with six dress-up costumes beside it'},
        {key: 'historical', label: 'Historical costumes', subject: 'a doll with six costumes, Egyptian to 1920s flapper'},
    ],
    styles: [
        {key: 'vintage', label: 'Vintage', style: 'a 1940s printed-toy look, fine ink outlines', palette: 'soft faded lithograph, paper grain', framing: 'figure left, outfits laid flat, tabs and cut lines'},
        {key: 'kawaii', label: 'Kawaii', style: 'a big-headed rounded figure, thick soft outlines', palette: 'pastel, blushing cheeks', framing: 'figure left, outfits laid flat, tabs and cut lines'},
        {key: 'watercolor', label: 'Watercolor', style: 'transparent washes, pencil linework showing through', palette: 'visible pigment pooling', framing: 'figure left, outfits laid flat, tabs and cut lines'},
    ],
    directions: ['a boy doll instead', 'in a bright primary palette', 'fewer outfits, drawn larger'],
}
